export default __webpack_public_path__ + "31dddbc9792dbe3f1fc7a6806259663a.png";